var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.25C1.16848 0.25 0.850537 0.381696 0.616116 0.616116C0.381696 0.850537 0.25 1.16848 0.25 1.5V7.2325C0.250071 7.56399 0.381813 7.88188 0.61625 8.11625L9.36625 16.8663C9.60066 17.1006 9.91854 17.2322 10.25 17.2322C10.5815 17.2322 10.8993 17.1006 11.1337 16.8663L16.8663 11.1337C17.1006 10.8993 17.2322 10.5815 17.2322 10.25C17.2322 9.91854 17.1006 9.60066 16.8663 9.36625L8.11625 0.61625C7.88188 0.381813 7.56399 0.250071 7.2325 0.25H1.5ZM6.5 4.625C6.5 5.12228 6.30246 5.59919 5.95083 5.95083C5.59919 6.30246 5.12228 6.5 4.625 6.5C4.12772 6.5 3.65081 6.30246 3.29917 5.95083C2.94754 5.59919 2.75 5.12228 2.75 4.625C2.75 4.12772 2.94754 3.65081 3.29917 3.29917C3.65081 2.94754 4.12772 2.75 4.625 2.75C5.12228 2.75 5.59919 2.94754 5.95083 3.29917C6.30246 3.65081 6.5 4.12772 6.5 4.625Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.fcd81783a5d36d5f552bd359d63344d7.svg";
export { ForwardRef as ReactComponent };